(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8880],{

/***/ 2289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgTelephone(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 510.003 510.003",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M68.787 239.517L34.394 273.91 0 308.304v201.213h255.002l10-195-10-195.001H255l-97.998-9.848z",
    fill: "#27e7f0"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M255.002 119.516v390.001H510V308.304l-34.392-34.394-34.395-34.393L360 119.516zM86.94 30.944c-12.17 5.239-23.153 11.053-32.892 17.399-11.157 7.271-20.68 15.244-28.482 23.858-8.203 9.058-14.451 18.731-18.718 28.952C2.393 111.828.1 123.1.001 134.891v22.312L0 179.516l75 10 75-10v-15c0-13.214 17.378-27.402 44.98-36.238 16.768-5.368 37.309-8.762 60.02-8.762h.002l10-59.513-10-59.513c-29.729.102-58.605 2.525-85.56 7.083-30.47 5.152-58.486 13.031-82.502 23.371z",
    fill: "#3ac0f1"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M360 164.516v15l75 10 75-10v-44.44c.179-23.511-8.14-44.799-24.46-63.234-13.471-15.217-32.394-28.49-56.489-39.466-23.479-10.693-51.366-18.904-81.996-24.315C320.334 3.34 291.527.751 261.739.503a631.277 631.277 0 00-3.368-.017c-1.124-.002-2.246 0-3.368.004v119.026c22.711.001 43.252 3.394 60.019 8.762C342.623 137.115 360 151.302 360 164.516z",
    fill: "#3a97f1"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M360 239.517h150V179.516H360v30z",
    fill: "#3a77f1"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M150 239.517H0v-60.001h150z",
    fill: "#3a97f1"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M350 344.517l8.925 15H390v-30H358.925z",
    fill: "#ccd2db"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M255 239.517c-28.948 0-55.198 11.775-74.211 30.788S150 315.568 150 344.517c0 28.948 11.776 55.198 30.789 74.211s45.263 30.789 74.211 30.789h.002l10-105-10-105h-.001z",
    fill: "#f3f5f9"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M360 344.517c0-28.949-11.775-55.199-30.787-74.212-19.013-19.013-45.263-30.788-74.211-30.788v210c28.948-.001 55.198-11.776 74.211-30.789C348.225 399.714 360 373.465 360 344.517z",
    fill: "#e1e6f0"
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M255 299.517c-12.406 0-23.656 5.046-31.805 13.194C215.047 320.86 210 332.11 210 344.517c0 12.406 5.047 23.656 13.195 31.805 8.148 8.148 19.398 13.195 31.805 13.195h.002l10-45-10-45h-.001z",
    fill: "#e1e6f0"
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M300 344.517c0-12.407-5.046-23.657-13.194-31.805-8.147-8.148-19.397-13.195-31.804-13.195v90c12.406-.001 23.656-5.048 31.804-13.196S300 356.923 300 344.517z",
    fill: "#ccd2db"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgTelephone);

/***/ }),

/***/ 53679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ResponsiveContainer; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.module.scss.js


var css_248z = ".ResponsiveContainer-module_container_box__vbXde {\n  display: flex;\n  flex-wrap: wrap;\n}";
var Styles = {"container_box":"ResponsiveContainer-module_container_box__vbXde"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=ResponsiveContainer.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.js





const ResponsiveContainer = (_a) => {
    var { className, id } = _a, props = (0,_tslib/* __rest */._)(_a, ["className", "id"]);
    return (react.createElement("div", { id: id, className: classnames_default()(Styles.container_box, className) }, props.children));
};


//# sourceMappingURL=ResponsiveContainer.js.map


/***/ }),

/***/ 84445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Located_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80893);
/* harmony import */ var _Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Located_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70561);
/* harmony import */ var _vahak_core_dist_components_app_btn_AppBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49995);
/* harmony import */ var _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51061);







var Located = function() {
    var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heading),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    children: [
                        "We’re located at the",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            "data-hover": "heart of Bangalore",
                            className: isMobile ? "" : "indaiText",
                            children: "heart of Bangalore"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().locatedRow),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().locatedMapCol),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                            src: _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_DETAILS.googleMapEmbedLink */ .S.googleMapEmbedLink,
                            width: "460",
                            style: {
                                border: "0px",
                                width: "100%",
                                borderRadius: "15px",
                                height: isMobile ? "200px" : "415px"
                            },
                            loading: "lazy",
                            title: "Vahak Office Map"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().locatedAddressCol),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().addressBox),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().col),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_DETAILS.workspace */ .S.workspace
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().col),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_DETAILS.address */ .S.address
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    openInNewTab: true,
                                    href: _vahak_core_dist_constants_companyDetails__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_DETAILS.googleMapLink */ .S.googleMapLink,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_app_btn_AppBtn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        className: (_Located_module_scss__WEBPACK_IMPORTED_MODULE_6___default().viewMapButton),
                                        children: "View on Maps"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Located);


/***/ }),

/***/ 96696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83347);
/* harmony import */ var _methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61706);
/* harmony import */ var _vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28230);






var getCityMetaDescription = function(cityName) {
    return "Book ".concat(_vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__/* .PLATFORM_STATS.liveLoadsAndLorries.label */ .s.liveLoadsAndLorries.label, " loads and lorries in ").concat(cityName, "! Vahak is the #1 platform for ").concat(cityName, " transport services. Join India's largest transporter network today for free.");
};
/**
 * Registers page SEO with the global SeoProvider.
 * Rendering is handled by GlobalSeoHead in _app — route defaults live in methods/pageSeo.ts.
 */ var PageMetaTags = function(param) {
    var cityName = param.cityName, titleProp = param.title, descriptionProp = param.description, _keywords = param.keywords, keywords = _keywords === void 0 ? "" : _keywords, asPath = param.asPath, locale = param.locale, localeNeutralPath = param.localeNeutralPath, hreflangLocales = param.hreflangLocales, canonicalUrlProp = param.canonicalUrl, ogUrl = param.ogUrl, ogDescription = param.ogDescription, _ogImgSrc = param.ogImgSrc, ogImgSrc = _ogImgSrc === void 0 ? (0,_methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultOgImage */ .av)() : _ogImgSrc, ogImgAltTextProp = param.ogImgAltText, ogType = param.ogType, ogSiteName = param.ogSiteName, schema = param.schema, schemaOrgJsonUrlProp = param.schemaOrgJsonUrl, _includeDefaultSchema = param.includeDefaultSchema, includeDefaultSchema = _includeDefaultSchema === void 0 ? false : _includeDefaultSchema, _shouldBeIndexed = param.shouldBeIndexed, shouldBeIndexed = _shouldBeIndexed === void 0 ? true : _shouldBeIndexed, breadcrumbList = param.breadcrumbList, _schemaType = param.schemaType, schemaType = _schemaType === void 0 ? "WebPage" : _schemaType, faqList = param.faqList, children = param.children;
    var title = titleProp !== null && titleProp !== void 0 ? titleProp : cityName ? "Vahak - Book Best Transport Services in ".concat(cityName) : undefined;
    var description = descriptionProp !== null && descriptionProp !== void 0 ? descriptionProp : cityName ? getCityMetaDescription(cityName) : undefined;
    var canonicalUrl = canonicalUrlProp !== null && canonicalUrlProp !== void 0 ? canonicalUrlProp : cityName ? "https://www.vahak.in/city/".concat(cityName) : undefined;
    var schemaOrgJsonUrl = schemaOrgJsonUrlProp !== null && schemaOrgJsonUrlProp !== void 0 ? schemaOrgJsonUrlProp : cityName ? "/city/".concat(cityName) : undefined;
    var ogImgAltText = ogImgAltTextProp !== null && ogImgAltTextProp !== void 0 ? ogImgAltTextProp : description;
    var seoConfig = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            title: title,
            description: description,
            keywords: keywords,
            asPath: asPath,
            locale: locale,
            localeNeutralPath: localeNeutralPath,
            hreflangLocales: hreflangLocales,
            canonicalUrl: asPath ? undefined : canonicalUrl,
            ogUrl: ogUrl,
            ogDescription: ogDescription,
            ogImgSrc: ogImgSrc,
            ogImgAltText: ogImgAltText,
            ogType: ogType,
            ogSiteName: ogSiteName,
            schema: schema,
            schemaOrgJsonUrl: schemaOrgJsonUrl,
            includeDefaultSchema: includeDefaultSchema,
            shouldBeIndexed: shouldBeIndexed,
            breadcrumbList: breadcrumbList,
            schemaType: schemaType,
            faqList: faqList
        };
    }, [
        title,
        description,
        keywords,
        asPath,
        locale,
        localeNeutralPath,
        hreflangLocales,
        canonicalUrl,
        ogUrl,
        ogDescription,
        ogImgSrc,
        ogImgAltText,
        ogType,
        ogSiteName,
        schema,
        schemaOrgJsonUrl,
        includeDefaultSchema,
        shouldBeIndexed,
        breadcrumbList,
        schemaType,
        faqList
    ]);
    (0,_seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__/* .useRegisterPageSeo */ .C9)(seoConfig);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaTags);


/***/ }),

/***/ 62307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useDefaultTopLayout; }
/* harmony export */ });
/* unused harmony export useHomePageDefaultLayout */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99456);
/* harmony import */ var _default_layout_DefaultLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78485);
/* harmony import */ var _dashboard_navbar_DashboardNavbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51938);




var useDefaultTopLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* .DefaultTopNavLayout */ .U1, {
        children: page
    });
};
var useHomePageDefaultLayout = function(page) {
    return /*#__PURE__*/ _jsx(DefaultLayout, {
        navContent: /*#__PURE__*/ _jsx(DashboardNav, {}),
        children: page
    });
};


/***/ }),

/***/ 6503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactUs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/misc/contact-us/ContactUs.module.scss
var ContactUs_module = __webpack_require__(15773);
var ContactUs_module_default = /*#__PURE__*/__webpack_require__.n(ContactUs_module);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/methods/copyToClipboard.js
var copyToClipboard = __webpack_require__(54534);
// EXTERNAL MODULE: ./components/misc/contact-us/ContactCard/ContactCard.module.scss
var ContactCard_module = __webpack_require__(2339);
var ContactCard_module_default = /*#__PURE__*/__webpack_require__.n(ContactCard_module);
// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
;// CONCATENATED MODULE: ./components/misc/contact-us/ContactCard/ContactCard.tsx






var ContactUsCard = function(param) {
    var icon = param.icon, className = param.className, heading = param.heading, contentText = param.contentText, specialText = param.specialText, footerText = param.footerText, onClickCard = param.onClickCard;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var ref = (0,react.useState)(false), isCardHovered = ref[0], setIsCardHovered = ref[1];
    var onHover = (0,react.useCallback)(function() {
        setIsCardHovered(true);
    }, []);
    var onMouseOut = (0,react.useCallback)(function() {
        setIsCardHovered(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
            onClick: onClickCard,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((ContactCard_module_default()).contactcard, isMobile ? (ContactCard_module_default()).contactcard__mobile__container : (ContactCard_module_default()).contactcard__desktop__container, isCardHovered && (ContactCard_module_default()).hover, className),
                onMouseEnter: onHover,
                onMouseLeave: onMouseOut,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((ContactCard_module_default()).contactCardHeader, isMobile ? (ContactCard_module_default()).contactCardHeader__mob : (ContactCard_module_default()).contactCardHeader__web),
                        children: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((ContactCard_module_default()).headingTextCommon, isMobile ? (ContactCard_module_default()).headingText__mob : (ContactCard_module_default()).headingText__web),
                        children: isMobile ? heading : /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: heading
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: classnames_default()((ContactCard_module_default()).contentTextCommon, isMobile ? (ContactCard_module_default()).contentText__mob : (ContactCard_module_default()).contentText__web),
                        children: [
                            contentText,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()((ContactCard_module_default()).headingTextCommon, isMobile ? (ContactCard_module_default()).specialText__mob : (ContactCard_module_default()).specialText__web),
                                children: specialText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                        className: classnames_default()((ContactCard_module_default()).footerCommon, isMobile ? (ContactCard_module_default()).footerText__mob : (ContactCard_module_default()).footerText__web),
                        children: footerText
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ContactCard = (ContactUsCard);

// EXTERNAL MODULE: ../core/dist/icons/telephone.svg
var telephone = __webpack_require__(2289);
;// CONCATENATED MODULE: ../core/dist/icons/Phones.svg
var _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgPhones(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M511.914 256c0-141.387-114.594-256-255.957-256C114.597 0 0 114.613 0 256s114.598 256 255.957 256c141.363 0 255.957-114.613 255.957-256zm0 0",
    fill: "#66d15f"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M417.09 57.102c35.691 44.007 57.094 100.078 57.094 161.16 0 141.383-114.598 256-255.957 256-61.07 0-117.133-21.407-161.133-57.106C104.024 475.012 175.664 512 255.957 512c141.363 0 255.957-114.613 255.957-256 0-80.305-36.98-151.96-94.824-198.898zm0 0",
    fill: "#53bc77"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M326.531 306.543l-26.3 19.809c-4.926 3.71-11.68 3.914-16.794.46-37.472-25.328-65.566-62.644-79.546-105.664-1.907-5.867.156-12.3 5.082-16.011l26.511-19.965a6.79 6.79 0 002.66-6.27 159.77 159.77 0 01-1.269-22.464c.156-11.22-8.59-21.676-19.7-23.243l-23.097-3.254c-27.523-3.882-48.683 15.653-47.07 43.407a248.845 248.845 0 0013.695 68.14c17.164 48.77 49.14 91.239 91.258 121.215a248.558 248.558 0 0061.687 31.992c26.223 9.227 50.84-5.715 54.72-33.246l3.187-22.62c1.57-11.142-5.97-22.88-16.82-25.84a159.504 159.504 0 01-21-7.325 7.22 7.22 0 00-7.204.879zm0 0",
    fill: "#d4ffdf"
  })), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fill: "#b1ffc5"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M190.258 133.195c11.105 1.567 19.855 12.024 19.699 23.243-.105 7.59.328 15.09 1.27 22.464a6.783 6.783 0 01-2.665 6.27l-26.507 19.96c-4.926 3.716-6.989 10.15-5.082 16.016 13.98 43.016 42.074 80.332 79.547 105.66 5.109 3.458 11.863 3.25 16.789-.46l4.574-3.446c-34.692-25.183-60.707-60.89-73.992-101.754-1.907-5.867.156-12.304 5.086-16.015l26.507-19.961a6.783 6.783 0 002.664-6.27 159.217 159.217 0 01-1.273-22.465c.156-11.222-8.59-21.68-19.7-23.242l-23.097-3.258c-6.734-.949-13.082-.488-18.812 1.145zm0 0M354.734 312.988a159.465 159.465 0 01-20.996-7.328 7.236 7.236 0 00-7.207.883l-5.75 4.332c2.32.75 4.66 1.469 7.035 2.113 10.852 2.957 18.391 14.7 16.82 25.84l-3.187 22.621c-2.379 16.899-12.582 29.04-26.164 33.778 25.602 8.05 49.29-6.82 53.086-33.778l3.188-22.62c1.57-11.142-5.97-22.884-16.825-25.84zm0 0"
  }))));
}

/* harmony default export */ var Phones = (SvgPhones);
// EXTERNAL MODULE: ./components/careers/located/Located.tsx
var Located = __webpack_require__(84445);
// EXTERNAL MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(53679);
// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/companyDetails.js
var companyDetails = __webpack_require__(51061);
// EXTERNAL MODULE: ./hooks/useCallbackRequestedState.ts
var useCallbackRequestedState = __webpack_require__(87129);
// EXTERNAL MODULE: ./constants/modal-strings.ts
var modal_strings = __webpack_require__(83463);
// EXTERNAL MODULE: ./hooks/useToggleModal.tsx
var useToggleModal = __webpack_require__(91467);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/_services/callMeBack.service.js
var callMeBack_service = __webpack_require__(79890);
;// CONCATENATED MODULE: ./components/misc/contact-us/ContactUs.tsx















// Constants







var CallbackRequest = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 92659)).catch(function() {
        return function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        };
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92659)
            ];
        }
    },
    ssr: false
});
var ContactUsComponent = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "contactus"
    ]).t;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var toggleCBRModal = (0,useCallbackRequestedState/* useToggleCBRModal */.l)().toggleCBRModal;
    // const [isCallbackRequestPopupVisible, setisCallbackRequestPopupVisible] = useState(false);
    var ref = (0,useToggleModal/* useToggleModal */.x)(modal_strings/* CONTACT_US_CALL_BACK_REQUEST */.Aq), openLoadBidModal = ref.openModal, closeLoadBidModal = ref.closeModal;
    var router = (0,next_router.useRouter)();
    // const onClickWhatsapp = () => {
    //     window.open(
    //         isMobile ? VAHAK_WHATSAPP_LINK_MOBILE : VAHAK_WHATSAPP_LINK_DESKTOP,
    //         "_blank",
    //         "noopener noreferrer"
    //     );
    // };
    var toggleCallBackRequestModal = function() {
        if (!router.asPath.includes(modal_strings/* CONTACT_US_CALL_BACK_REQUEST */.Aq)) {
            if (toggleCBRModal()) {
                openLoadBidModal();
            }
        } else {
            closeLoadBidModal();
        }
    };
    var onClickEmail = function() {
        (0,copyToClipboard/* copyToClipboard */.v)(misc/* VAHAK_EMAIL */.xA, "Email Id copied!");
    // if (isMobile) {
    //     window.open(`mailto:${VAHAK_EMAIL}`, "_blank", "noopener noreferrer");
    // } else {
    //     copyToClipboard(VAHAK_EMAIL, "Email Id copied!");
    // }
    };
    var onClickEmail_Info = function() {
        if (isMobile) {
            window.open("mailto:".concat(misc/* VAHAK_EMAIL_INFO */.aS), "_blank", "noopener noreferrer");
        } else {
            (0,copyToClipboard/* copyToClipboard */.v)(misc/* VAHAK_EMAIL_INFO */.aS, "Email Id copied!");
        }
    };
    var onClickPhone = function() {
        if (isMobile) {
            window.open("tel:".concat(companyDetails/* COMPANY_DETAILS.telephone */.S.telephone), "_self");
        } else {
            (0,copyToClipboard/* copyToClipboard */.v)(companyDetails/* COMPANY_DETAILS.telephone */.S.telephone, "Phone number copied!");
        }
    };
    (0,react.useEffect)(function() {
    // window.prerenderReady = true;
    }, []);
    var description = "Get in touch with us for any kind of LCV, truck, or container related queries. Contact us at +91-8035738071 or email us at cs@vahak.in";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                title: "Vahak - Contact Us",
                description: description,
                keywords: "find truck loads online, vahak, vahak app, truck loads app, book my truck,transportation apps in india",
                canonicalUrl: "https://www.vahak.in/contact-us",
                ogUrl: "https://www.vahak.in/contact-us",
                ogImgAltText: description,
                schemaOrgJsonUrl: "/contact-us",
                includeDefaultSchema: false,
                schemaType: "WebPage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(isMobile ? (ContactUs_module_default()).contactUs__mob : (ContactUs_module_default()).contactUs__web),
                style: {
                    marginTop: isMobile ? "55px" : "74px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        className: classnames_default()((ContactUs_module_default()).headerBaground, isMobile ? (ContactUs_module_default()).header__mob : (ContactUs_module_default()).header__web),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: classnames_default()((ContactUs_module_default()).textCommon, isMobile ? (ContactUs_module_default()).headingText__mob : (ContactUs_module_default()).headingText__web),
                                children: isMobile ? t("contactus:contactUs") : /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    children: [
                                        " ",
                                        t("contactus:contactUs")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: classnames_default()((ContactUs_module_default()).textCommon, isMobile ? (ContactUs_module_default()).headingSubText__mob : (ContactUs_module_default()).headingSubText__web),
                                children: isMobile ? "".concat(t("contactus:getintouchand_letusknow_queries")) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    children: [
                                        t("contactus:getintouchand_letusknow_queries"),
                                        " "
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveContainer/* default */.Z, {
                        className: classnames_default()(isMobile ? (ContactUs_module_default()).cardargin__mob : (ContactUs_module_default()).cardargin__web),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactCard, {
                                heading: t("contactus:contactus_card.request_call_back"),
                                contentText: t("contactus:contactus_card.request_call_back_text"),
                                specialText: companyDetails/* COMPANY_DETAILS.openHours */.S.openHours,
                                footerText: t("contactus:contactus_card.raise_callback_request"),
                                className: (ContactUs_module_default()).card,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(telephone/* default */.Z, {
                                    className: classnames_default()(isMobile ? (ContactUs_module_default()).iconmob : (ContactUs_module_default()).iconweb)
                                }),
                                onClickCard: toggleCallBackRequestModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactCard, {
                                heading: t("contactus:contactus_card.call_us"),
                                contentText: t("contactus:contactus_card.call_us_text"),
                                specialText: companyDetails/* COMPANY_DETAILS.openHours */.S.openHours,
                                footerText: companyDetails/* COMPANY_DETAILS.telephone */.S.telephone,
                                className: (ContactUs_module_default()).card,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Phones, {
                                    className: classnames_default()(isMobile ? (ContactUs_module_default()).iconmob : (ContactUs_module_default()).iconweb)
                                }),
                                onClickCard: onClickPhone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((ContactUs_module_default()).centerDiv),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()(isMobile ? (ContactUs_module_default()).centerDiv_align__mob : (ContactUs_module_default()).centerDiv_align__web),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                                        onClick: onClickEmail,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: classnames_default()((ContactUs_module_default()).centerTextCommon, isMobile ? (ContactUs_module_default()).centerTextCommon__text__mob : (ContactUs_module_default()).centerTextCommon__text__web),
                                                children: [
                                                    " ",
                                                    t("contactus:general_communication")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()((ContactUs_module_default()).centercontentCommon, isMobile ? (ContactUs_module_default()).centercontentCommon__text__mob : (ContactUs_module_default()).centercontentCommon__text__web),
                                                children: [
                                                    t("contactus:for_general_queries"),
                                                    ":",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: classnames_default()((ContactUs_module_default()).centercontentCommon__span),
                                                        children: "cs@vahak.in"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        backgroundColor: "#E9E9E9",
                                        height: "1px",
                                        width: "100%",
                                        marginTop: "26px",
                                        marginBottom: "26px"
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        backgroundColor: "#E9E9E9",
                                        height: "60px",
                                        width: "1px",
                                        marginLeft: "45px",
                                        marginRight: "45px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                                        onClick: onClickEmail_Info,
                                        children: [
                                            t("contactus:for_partnerships"),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " ",
                                            t("contactus:related_queries"),
                                            ":",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: classnames_default()((ContactUs_module_default()).centercontentCommon__span),
                                                children: "info@vahak.in"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: classnames_default()(isMobile ? (ContactUs_module_default()).locationMargin__mob : (ContactUs_module_default()).locationMargin__web),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Located/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CallbackRequest, {
                isCallbackRequestPopupVisible: !!router.asPath.includes(modal_strings/* CONTACT_US_CALL_BACK_REQUEST */.Aq),
                toggleCallBackRequestModal: toggleCallBackRequestModal,
                onSubmit: function onSubmit() {
                    closeLoadBidModal();
                },
                sourceScreen: callMeBack_service/* CallMeBackScreen.CONTACT_US */.s.CONTACT_US
            })
        ]
    });
};
/* harmony default export */ var ContactUs = (ContactUsComponent);


/***/ }),

/***/ 24145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": function() { return /* binding */ getWhyChooseUsPageLayout; },
/* harmony export */   "Y$": function() { return /* binding */ getAboutUsPageLayout; },
/* harmony export */   "ad": function() { return /* binding */ getHowVahakHelpsPageLayout; },
/* harmony export */   "m2": function() { return /* binding */ getDefaultTopLayout; },
/* harmony export */   "sA": function() { return /* binding */ getContactUsPageLayout; }
/* harmony export */ });
/* unused harmony export getHomePageLayout */
/* harmony import */ var components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62307);

/***
 *  Default Layout
 */ var getDefaultTopLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * About Us
 */ var getAboutUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * how vahak helps
 */ var getHowVahakHelpsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Contact Us
 */ var getContactUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Whu Choose Us
 */ var getWhyChooseUsPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_0__/* .useDefaultTopLayout */ .E;
/***
 * Home
 */ var getHomePageLayout = (/* unused pure expression or super */ null && (useHomePageDefaultLayout));


/***/ }),

/***/ 83463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ CONTACT_US_CALL_BACK_REQUEST; },
/* harmony export */   "aP": function() { return /* binding */ CONTACT_DAILY_LIMIT; },
/* harmony export */   "eO": function() { return /* binding */ CALL_BACK_REQUEST; },
/* harmony export */   "xg": function() { return /* binding */ SUPPORT_MENU; },
/* harmony export */   "ym": function() { return /* binding */ LOGIN; }
/* harmony export */ });
/* unused harmony exports SERVICE_TYPE_MODAL, CONFIRM_CANCEL_MODAL, LOAD_BID, LORRY_BID, MOBILE_FILTERS_MARKETPLACE, SRC_SEARCH_VISIBLE, DEST_SEARCH_VISIBLE, HOMEPAGE_SRC_SEARCH_VISIBLE, HOMEPAGE_DEST_SEARCH_VISIBLE, LOAD_POSTING_FORM, LORRY_POSTING_FORM, SHARE_MODAL */
var SERVICE_TYPE_MODAL = "ServiceTypeModal";
var CONFIRM_CANCEL_MODAL = "ConfirmCancelModal";
var LOAD_BID = "loadbid";
var LORRY_BID = "lorrybid";
var SUPPORT_MENU = "SupportMenu";
var CALL_BACK_REQUEST = "CallBackReq";
var CONTACT_US_CALL_BACK_REQUEST = "ContactUsCallBack";
var MOBILE_FILTERS_MARKETPLACE = "Filters";
var SRC_SEARCH_VISIBLE = "SourceSearchVisible";
var DEST_SEARCH_VISIBLE = "DestinationSearchVisible";
var HOMEPAGE_SRC_SEARCH_VISIBLE = "SourceSearch";
var HOMEPAGE_DEST_SEARCH_VISIBLE = "DestinationSearch";
var CONTACT_DAILY_LIMIT = "contact-daily-limit";
var LOGIN = "Login";
var LOAD_POSTING_FORM = "LoadPostingForm";
var LORRY_POSTING_FORM = "LorryPostingForm";
var SHARE_MODAL = "ShareModal";


/***/ }),

/***/ 87129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useToggleCBRModal; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63118);
/* harmony import */ var _vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77370);
/* harmony import */ var _vahak_core_dist_methods_getTimeDiffMs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55622);
/* harmony import */ var _useValidateUserStatus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4641);




function useToggleCBRModal() {
    var loginCheck = (0,_useValidateUserStatus__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().loginCheck;
    // Check if callback is requested less than 24 hours
    var checkCallbackRequestedTimeStamp = function() {
        var oneDay = 60 * 60 * 24 * 1000;
        var callbackTimestamp = window.localStorage.getItem(_vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__/* .LOC_STORAGE.callbackRequestedTimestamp */ .wO.callbackRequestedTimestamp);
        // Check if callback is requested less than 24 hours
        if (callbackTimestamp === ( false || null) || (0,_vahak_core_dist_methods_getTimeDiffMs__WEBPACK_IMPORTED_MODULE_3__/* .getTimeDiffMs */ .y)(callbackTimestamp, new Date().toISOString()) > oneDay) {
            return true;
        } else {
            return false;
        }
    };
    /**
     * Custom Hooks
     */ // const { openModal, closeModal } = useHandleModalToggle(["isCallbackRequestPopupVisible"]);
    var toggleCBRModal = function() {
        var isCallbackRequestPopupVisible = false;
        // if (!isCallbackRequestPopupVisible) {
        if (checkCallbackRequestedTimeStamp()) {
            isCallbackRequestPopupVisible = true;
        } else {
            _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_0__/* .toast.info */ .A.info("Your request is being processed, we'll get back to you shortly");
            return false;
        }
        return isCallbackRequestPopupVisible;
    };
    return {
        toggleCBRModal: function() {
            return loginCheck("none", toggleCBRModal);
        },
        checkCallbackRequestedTimeStamp: checkCallbackRequestedTimeStamp
    };
}


/***/ }),

/***/ 91467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useToggleModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _methods_getPathName__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48929);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);



function useToggleModal(modalName) {
    var handleToggle = function() {
        if (!next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath.includes(modalName)) {
            openModal(modalName);
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: undefined
            }, undefined, {
                shallow: true
            });
        }
    };
    var openModal = function(currentModalName) {
        modalName = currentModalName || modalName;
        var currentHash = next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath.split("#").slice(1).join("#");
        if (currentHash && !currentHash.includes(modalName)) {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: "".concat(currentHash, "#").concat(modalName)
            }, undefined, {
                shallow: true
            });
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: modalName
            }, undefined, {
                shallow: true
            });
        }
    };
    var closeModal = function(currentModalName) {
        modalName = currentModalName || modalName;
        var numOfModalsOpen = next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath.split("#").length - 1;
        var currentHash = next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath.split("#").slice(1).join("#");
        if (numOfModalsOpen > 1) {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: currentHash.replace("#".concat(modalName), "")
            }, undefined, {
                shallow: true
            });
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: undefined
            }, undefined, {
                shallow: true
            });
        }
    };
    return {
        handleToggle: handleToggle,
        openModal: openModal,
        closeModal: closeModal
    };
}


/***/ }),

/***/ 80893:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"Located_heading__E6e0y","locatedRow":"Located_locatedRow__rHFgE","locatedMapCol":"Located_locatedMapCol__KpAEN","addressBox":"Located_addressBox__5afdP","row":"Located_row__htoTF","col":"Located_col__fMcXp","viewMapButton":"Located_viewMapButton__WKIEf","locatedAddressCol":"Located_locatedAddressCol__HwUS0"};

/***/ }),

/***/ 2339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactcard":"ContactCard_contactcard__Jtd39","hover":"ContactCard_hover__aaEAF","contactcard__mobile__container":"ContactCard_contactcard__mobile__container__wSuZg","contactcard__desktop__container":"ContactCard_contactcard__desktop__container__gI5Ya","contactCardHeader":"ContactCard_contactCardHeader__a6H5r","contactCardHeader__web":"ContactCard_contactCardHeader__web__rbJB7","contactCardHeader__mob":"ContactCard_contactCardHeader__mob__zNaZv","headingTextCommon":"ContactCard_headingTextCommon__20fK9","headingText__web":"ContactCard_headingText__web__ofQ2Z","headingText__mob":"ContactCard_headingText__mob__d9Hap","contentTextCommon":"ContactCard_contentTextCommon__QCRMn","contentText__web":"ContactCard_contentText__web__uhgTg","contentText__mob":"ContactCard_contentText__mob___1__O","specialText__web":"ContactCard_specialText__web__upZdv","specialText__mob":"ContactCard_specialText__mob__GWGbB","footerCommon":"ContactCard_footerCommon__NEEc1","footerText__web":"ContactCard_footerText__web__zffux","footerText__mob":"ContactCard_footerText__mob__Fci7y"};

/***/ }),

/***/ 15773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactUs__web":"ContactUs_contactUs__web__9UlFg","header__web":"ContactUs_header__web__voWja","headingText__web":"ContactUs_headingText__web__jjfNL","headingSubText__web":"ContactUs_headingSubText__web__AF8gk","cardargin__web":"ContactUs_cardargin__web__si2yY","card":"ContactUs_card__dU_xV","centerTextCommon__text__web":"ContactUs_centerTextCommon__text__web__aCOG7","centercontentCommon__text__web":"ContactUs_centercontentCommon__text__web__BbFU5","locationMargin__web":"ContactUs_locationMargin__web__6AH5U","iconweb":"ContactUs_iconweb__Slsl_","headerBaground":"ContactUs_headerBaground__UVfqO","centerDiv":"ContactUs_centerDiv__i8Bjv","centerDiv_align__web":"ContactUs_centerDiv_align__web__p91E9","centerTextCommon":"ContactUs_centerTextCommon__0QaRZ","centercontentCommon":"ContactUs_centercontentCommon__w45Kd","centercontentCommon__span":"ContactUs_centercontentCommon__span__Q7MfO","textCommon":"ContactUs_textCommon__zAHIG","contactUs__mob":"ContactUs_contactUs__mob__L0gCI","header__mob":"ContactUs_header__mob__P7KZh","headingText__mob":"ContactUs_headingText__mob___Ogl_","headingSubText__mob":"ContactUs_headingSubText__mob__E6L99","cardargin__mob":"ContactUs_cardargin__mob__l_fC8","centerDiv_align__mob":"ContactUs_centerDiv_align__mob__Fw_tn","centerTextCommon__text__mob":"ContactUs_centerTextCommon__text__mob__7Kh9L","centercontentCommon__text__mob":"ContactUs_centercontentCommon__text__mob__ETfcb","locationMargin__mob":"ContactUs_locationMargin__mob__vbV4z","iconmob":"ContactUs_iconmob__uxBLr"};

/***/ })

}]);